<div class="store-container">
  <div class="store-header">
    <span class="store-name">{{ store?.name }}</span>
    <div class="store-actions">
      <mat-icon
        *ngIf="canEditStoreAndEditCodeAccount$ | async" 
        class="store-edit-icon" 
        (click)="editStoreClicked()">edit</mat-icon>
      <mat-icon
        *ngIf="canDeleteStore$ | async"
        class="store-edit-icon"
        (click)="deleteStoreClicked()">delete</mat-icon>
    </div>
  </div>
  <div class="store-subtitle">
    <span> {{ getAddress() }}</span>
  </div>
</div>
<ng-template #translatedItem let-item>{{ item.key | translate }}</ng-template>
